import { saveCookie, deleteCookie } from './cookie'

const REGION_COOKIE = 'region'

// cookie.js 의 getSaveCookie 는 unescape 를 사용해 한글(region_kr)이 깨지므로
// 리전 정보는 decodeURIComponent 로 직접 읽는다.
function readRegionCookie() {
  const target = `${REGION_COOKIE}=`
  const cookieList = document.cookie.split(';')

  for (let i = 0; i < cookieList.length; i++) {
    const cookie = cookieList[i].trim()
    if (cookie.indexOf(target) === 0) {
      return decodeURIComponent(cookie.substring(target.length))
    }
  }

  return ''
}

// 저장된 리전 정보, 없으면 null
const getRegion = () => {
  const raw = readRegionCookie()
  if (!raw) return null

  try {
    const region = JSON.parse(raw)

    if (!region || !region.region_code || !region.api) return null

    return region
  } catch (e) {
    return null
  }
}

const saveRegion = (region) => {
  saveCookie(REGION_COOKIE, encodeURIComponent(JSON.stringify(region)))
}

const deleteRegion = () => {
  deleteCookie(REGION_COOKIE)
}

// 선택된 리전의 api 주소, 선택 전이면 기본 서버
const apiUrl = () => {
  const region = getRegion()

  return (region && region.api) || process.env.VUE_APP_CONNECT
}

// 리전 목록은 항상 기본 서버에서 받아온다
const defaultApiUrl = () => process.env.VUE_APP_CONNECT

const socketUrl = () => {
  const region = getRegion()

  return (region && region.socket) || ''
}

const blobName = () => {
  const region = getRegion()

  return (region && region.blob) || 'argame3'
}

// 화면에 표시할 리전 이름
const regionLabel = (region, lang) => {
  if (!region) return ''

  return lang === 'ko' ? region.region_kr || region.region : region.region
}

export {
  getRegion,
  saveRegion,
  deleteRegion,
  apiUrl,
  defaultApiUrl,
  socketUrl,
  blobName,
  regionLabel
}
